import { connect } from "react-redux";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCrown, faGlobe } from "@fortawesome/pro-regular-svg-icons";
import { faInfoSquare, faUserSecret } from "@fortawesome/pro-light-svg-icons";

import { number } from "common/formats";
import { fetchRequestDetails, ADD_FILTER } from "common/actions/requests";

import { DetailsTable } from "../common/detailsTable";
import { DetailsBoxRedux } from "./detailsBox";

const mapStateToProps = (state) => ({
    // Which pieces of state should this component depend on? (cause a retrigger).
    queryDeps: {
        qualifiers: state.requests.qualifiers,
        date_range: state.common.date_range
    }
});

const mapDispatchToProps = {
    addFilter: ADD_FILTER
};

const ui = {
    columns: [
        {
            id: "_id",
            header: "",
            width: 38,
            css: "details-link",
            template: (item) => <span className="tooltipped tooltipped-ne" aria-label="Open request details"><FontAwesomeIcon icon={faInfoSquare} size="lg" className="open-details"/></span>
        },
        {
            id: "url",
            filter: "uri_template",
            header: "Request",
            width: 300,
            css: "filter-enable",
            template: (item) => `<code>${item.uri_template || item.url}</code>`
        },

        {
            id: "method",
            header: "Method",
            adjust: true,
            css: "filter-enable"
        },

        {
            id: "elapsed_time",
            header: "Duration",
            adjust: true,
            format: (value) => `${number(value * 1000, 2)}ms`
        },

        {
            id: "start_time",
            header: "Request start date (local)",
            adjust: true,
            format: (value) => moment.utc(value).local().format("MM-DD-YYYY h:mm:ss a")
        },

        {
            id: "username",
            header: "Username",
            adjust: true,
            format: (value) => value || "-",
            css: "filter-enable"
        },

        {
            id: "merchant",
            header: "Merchant",
            adjust: true,
            format: (value) => value || "-",
            css: "filter-enable"
        },

        {
            id: "product",
            header: "Product",
            adjust: true,
            format: (value) => value || "-",
            css: "filter-enable"
        },

        {
            id: "api_version",
            header: "API version",
            adjust: true,
            css: "filter-enable"
        },

        {
            id: "ip_address",
            header: "IP address",
            adjust: true,
            css: "filter-enable"
        },

        {
            id: "ip_address_country",
            header: "Country",
            adjust: "header",
            format: (value) => value || "-",
            css: "filter-enable"
        },

        {
            id: "status_code",
            header: "Status",
            adjust: "header",
            css: "filter-enable"
        },

        {
            id: "is_superuser",
            header: "User attrs",
            adjust: true,
            template: (item) => {
                const actions = [];

                if (item.is_superuser) {
                    actions.push({
                        key: "is_superuser",
                        icon: faUserCrown,
                        label: "Superuser"
                    });
                }

                if (item.is_wp_user) {
                    actions.push({
                        key: "is_wp_user",
                        icon: faGlobe,
                        // eslint-disable-next-line sentence-case/sentence-case
                        label: "Worldpay RM"
                    });
                }

                if (item.is_mimicked) {
                    actions.push({
                        key: "is_mimicked",
                        icon: faUserSecret,
                        label: "Mimicked user"
                    });
                }

                if (actions.length) {
                    return <div className="flex-content icons"> {actions.map(Action)} </div>;
                }

                return "-";
            }
        }
    ]
};

function Action({ label, icon, key }) {
    return <span key={key} className="tooltipped tooltipped-n control-icon" aria-label={label}><FontAwesomeIcon icon={icon}/></span>;
}

const Connected = connect(mapStateToProps, mapDispatchToProps)(DetailsTable);

export function RequestsDetailsRedux(props) {
    return (
        <Connected
            ui={ui}
            liveUpdates
            queryKey="requests"
            queryFn={fetchRequestDetails}
            renderDetails={(renderProps) => <DetailsBoxRedux {...renderProps} />}
            {...props}
        />
    );
}
